import { useQuery } from '@tanstack/react-query';
import type { AdminAuditRow, AdminPaged } from '@repo/shared-types';
import { adminFetchApi } from '../lib/api';

export interface AdminAuditListParams {
  page: number;
  limit: number;
  sort: string;
  q?: string;
  orgId?: string;
  action?: string;
}

export function useAdminAudit(p: AdminAuditListParams) {
  const qs = new URLSearchParams({ page: String(p.page), limit: String(p.limit), sort: p.sort });
  if (p.q) qs.set('q', p.q);
  if (p.orgId) qs.set('orgId', p.orgId);
  if (p.action) qs.set('action', p.action);
  return useQuery({
    queryKey: ['admin', 'audit', p],
    queryFn: () => adminFetchApi<AdminPaged<AdminAuditRow>>(`/admin/audit?${qs}`),
  });
}

/** Distinct `AuditLog.action` values across the whole table — used to
 *  populate the action filter dropdown so it isn't limited to whatever
 *  actions happen to be on the currently loaded page. */
export function useAdminAuditActions() {
  return useQuery({
    queryKey: ['admin', 'audit', 'actions'],
    queryFn: () => adminFetchApi<string[]>('/admin/audit/actions'),
  });
}
